import { PayloadAction } from '@reduxjs/toolkit';

import { ProductVariation, VariantsState } from '../types';

export interface ResolvedVariantPayload {
  productUid: string;
  attributes: Record<string, string>;
}

/**
 * Validates the resolved variant payload structure.
 */
const isValidPayload = (payload: ResolvedVariantPayload): boolean => {
  if (!payload) {
    return false;
  }

  const { productUid, attributes } = payload;

  if (!productUid || typeof productUid !== 'string') {
    return false;
  }

  if (!attributes || typeof attributes !== 'object' || Array.isArray(attributes)) {
    return false;
  }

  return true;
};

/**
 * Adds a newly resolved variant to the productVariations list.
 * Used for lazy variant loading - variants are resolved on-demand
 * when user changes options.
 */
const addResolvedVariantReducer = (state: VariantsState, action: PayloadAction<ResolvedVariantPayload>) => {
  const { payload } = action;

  // Validate payload structure
  if (!isValidPayload(payload)) {
    return;
  }

  const { productUid, attributes } = payload;

  const alreadyExists = state.product.productVariations.some((v) => v.productUid === productUid);

  if (!alreadyExists) {
    const newVariation: ProductVariation = { productUid, ...attributes };
    state.product.productVariations.push(newVariation);
  }
};

export default addResolvedVariantReducer;
